<div class="xvi-price-input-renderer" [ngClass]="class">
  <span *ngIf="label" class="price-input-label" [ngClass]="symbolPosition">{{ label }}</span>
  <input
    #inputElement
    [ngClass]="class"
    [attr.type]="type"
    [attr.placeholder]="placeholder"
    [attr.step]="step"
    [attr.disabled]="disabled ? 'true' : null"
    (keyup)="onKeyup($event)"
    (keydown)="onKeydown($event)"
    (focusin)="onFocusIn($event)"
    (focusout)="onFocusOut()"
    (gridCustomFocus)="onGridCustomFocus($event)"
    [(ngModel)]="value"
    [attr.customScanning]="true"
  />
</div>
